import { render, staticRenderFns } from "./Soal.vue?vue&type=template&id=6efa1ca6&scoped=true"
import script from "./Soal.vue?vue&type=script&lang=js"
export * from "./Soal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa1ca6",
  null
  
)

export default component.exports